import { ENVS } from './environments.constants';

export const environment = {
  production: false,
  apiUrl: ``,
  name: ENVS.TEST,
  cidiURl: 'https://cidi.test.cba.gov.ar',
  vediURl: 'https://vedi.test.cordoba.gob.ar/VeDiLandingPage',
  consultaPadronesQR: 'https://calidadalimentariadigital.test.cordoba.gob.ar/padrones/consulta-qr',
  filesUrl: 'https://dev-alimentos-s3-public.s3.amazonaws.com/'
};
